module.exports = __webpack_public_path__ + "img/zhengzaifangkuan.eed7513f.png";